module.exports = __webpack_public_path__ + "static/media/Mockups.f01591e0.png";